import { render, staticRenderFns } from "./TeamsportCategoryList.vue?vue&type=template&id=48f38fae&scoped=true"
import script from "./TeamsportCategoryList.vue?vue&type=script&lang=js"
export * from "./TeamsportCategoryList.vue?vue&type=script&lang=js"
import style0 from "./TeamsportCategoryList.vue?vue&type=style&index=0&id=48f38fae&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "48f38fae",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCol } from 'vuetify/lib/components/VGrid';
import { VContainer } from 'vuetify/lib/components/VGrid';
import { VDivider } from 'vuetify/lib/components/VDivider';
import { VProgressCircular } from 'vuetify/lib/components/VProgressCircular';
import { VRow } from 'vuetify/lib/components/VGrid';
installComponents(component, {VCol,VContainer,VDivider,VProgressCircular,VRow})
